import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-27/task-01";

const task: Slide = {
  titleHtml:
    "Sort the displayed bio-sourced and geo-sourced materials into appropriate groups<br>according to their predominant application from the acoustical point of view. Look at<br>each material as a stand-alone entity, not as a part of a more complex construction.",
  description: "Drag and drop pictures.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
